import { z } from "zod";

import { machineStatusSchema } from "./machine-status";
import { productionStatusSchema } from "./machine-production-status";
import { machineTypeSchema } from "./machine-type";
import { machineSecurePrintConfiguration } from "./machine-secure-print-configuration";
import { machineStopReasonSchema } from "./utils/machine-stop-reason";
import { machineWarningSchema } from "./utils/machine-warning";
import { NETWORK_PORT_MAX, NETWORK_PORT_MIN } from "./utils/constants";
import { machineWorkstationSchema } from "./utils/machine-workstation";

export const machineBaseSchema = z.object({
	id: z.string(),
	tenantId: z.string(),
	assetId: z.string(),

	alias: z.string(),
	description: z.string(),
	plcVersion: z.string(),
	machineType: machineTypeSchema,

	status: machineStatusSchema,
	productionStatus: productionStatusSchema,

	workstations: z.array(machineWorkstationSchema),
	stopReason: machineStopReasonSchema,
	activeWarnings: z.array(machineWarningSchema),

	iotDevice: z.object({
		deviceId: z.string(),
		deviceName: z.string(),

		hubName: z.string(),
		moduleId: z.string(),
		moduleVersion: z.string(),
		lastProofOfLife: z.coerce.date(),
	}),

	ipOrDnsName: z.string(),
	port: z.number().min(NETWORK_PORT_MIN).max(NETWORK_PORT_MAX),
	securePrintConfiguration: machineSecurePrintConfiguration,
});

export const createMachineBaseRequestSchema = z.object({
	alias: z.string(),
	ipOrDnsName: z.string(),
	port: z.number(),
	assetId: z.string(),
});

export type MachineBase = z.infer<typeof machineBaseSchema>;
export type CreateMachineBaseRequest = z.infer<typeof createMachineBaseRequestSchema>;
